import React from 'react';
import { Modal } from 'react-bootstrap';
import './declarationModal.css';
import edit_notifications from '../../../images/edit_notifications.png';

const DeclarationAmendmentModal = ({ showModal, onHide, onConfirm, jiraTicket = '' }) => {
  return (
    <Modal className="modal-height" animation={false} show={showModal} size="xl" centered onHide={onHide}>
      <Modal.Header>
        <Modal.Title>
          <div className="d-flex align-items-center justify-content-center">
            <img src={edit_notifications} alt="Declaration Amendment" width="30" style={{ marginRight: '15px' }} />
            Declaration has been flagged for Amendment
          </div>
        </Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>

      <Modal.Body className="py-4 modal-body-text">
        <p>
          This declaration has been amended and the data submitted in this supplementary declaration may be different to
          the SFD.
        </p>
        <br />
        <p>
          Please check the Jira Ticket{' '}
          <a
            href={`https://eoriuklimited.atlassian.net/browse/${jiraTicket}`}
            target="_blank"
            rel="noopener noreferrer"
            className="link-text"
          >
            {jiraTicket}
          </a>{' '}
          and ensure any of the changes are manually made after submitting from CABIE.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          <button className="epo-continue-button small-button" type="button" onClick={onHide}>
            Back
          </button>

          <button className="epo-continue-button small-button" type="button" onClick={onConfirm}>
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeclarationAmendmentModal;
